export const ActionTypes = {
  LOAD_PRODUCTS: "LOAD_PRODUCTS",
  // LOAD_POSTS: "LOAD_POSTS",
  // POPULATE_RACE_FORM: "POPULATE_RACE_FORM",
  // GET_RACE_INFO: "GET_RACE_INFO",
  // SAVE_RACE: "SAVE_RACE",
  // UPDATE_RACE_OBJECT: "UPDATE_RACE_OBJECT",
  // RESET_RACE: "RESET_RACE",
  UPDATE_LOGIN: "UPDATE_LOGIN",
  UPDATE_AUTH_TOKEN: "UPDATE_AUTH_TOKEN",
  UPDATE_USERNAME: "UPDATE_USERNAME",
};

export default ActionTypes;
